export class Tuple2<T1, T2> {

    constructor(public left: T1, public right: T2) {
    }

}
